import { Stack} from "@mui/material";
import React from "react";
import Register from "../login/Register";

const MyData = ({ setSuccess }) => {

	return (
		<Stack paddingTop={4} paddingBottom={2} width="100%" alignItems="center">
			<Register isUpdating={true} setSuccess={setSuccess} />
		</Stack>
	);
};

export default MyData;
